module.exports = __webpack_public_path__ + "static/img/about_fw_1.ad07a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about_fw_1.png
// module id = Pd/Q
// module chunks = 1